const ALLOTMENT_TYPES = [
    {
        label:"low allotment",
        type:"BAJO",
        lang:"Ingles",
        allotment:1
    }, {
        label:"average allotment",
        type:"MEDIO",
        lang:"Ingles",
        allotment:2
    }, {
        label:"high allotment",
        type:"ALTO",
        lang:"Ingles",
        allotment:3
    }, {
        label:"baja ocupación",
        type:"BAJO",
        lang:"Español",
        allotment:1
    }, {
        label:"ocupación media",
        type:"MEDIO",
        lang:"Español",
        allotment:2
    }, {
        label:"alta ocupación",
        type:"ALTO",
        lang:"Español",
        allotment:3
    }
]

export default ALLOTMENT_TYPES;